import Cookies from 'js-cookie'

import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'

export const SET_TAB_LAYERS_FILTER = 'SET_TAB_LAYERS_FILTER'

export const setTabLayersFilter = tabLayersFilter => {
  return dispatch => {
    dispatch({
      type: SET_TAB_LAYERS_FILTER,
      tabLayersFilter
    })
    Model.setState('filter', null, tabLayersFilter)
    HistoryUpdate()
    Cookies.set('pozi-state-filter', JSON.stringify(tabLayersFilter))
  }
}
